import { apolloClient } from '../../../App';

import { STOCK_TRANSFER_FRAGMENT } from 'data/fragments/stockTransfer';
import { GET_STOCK_TRANSFERS_QUERY } from 'data/queries/stockTransfer';

import { GetStockTransfersQuery, UpdateStockTransferMutation } from 'data/__generated__';

export const stockTransfersUpdatedHandler = (
    stockTransferUpdated: UpdateStockTransferMutation['updateStockTransfer']['stockTransfer'],
) => {
    if (!stockTransferUpdated) {
        return;
    }
    let currentStockTransfers = [] as GetStockTransfersQuery['stockTransfers']['stockTransfers'];
    let currentHasMore = false;
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetStockTransfersQuery>({
            query: GET_STOCK_TRANSFERS_QUERY,
        });
        if (!result) {
            throw Error('An error occurred when reading GET_STOCK_TRANSFERS_QUERY');
        }
        currentStockTransfers = result.stockTransfers.stockTransfers;
        currentHasMore = result.stockTransfers.hasMore;
    } catch {
        // do nothing
    }

    const stockTransferIds = currentStockTransfers.map(({ _id }) => _id);

    if (stockTransferIds.includes(stockTransferUpdated._id)) {
        // If this is a stockTransfer existing in the cache
        const data = {
            stockTransfers: {
                hasMore: currentHasMore,
                stockTransfers: currentStockTransfers.map((stockTransfer) => {
                    if (stockTransfer._id === stockTransferUpdated._id) {
                        return stockTransferUpdated;
                    }
                    return stockTransfer;
                }),
            },
        };
        apolloClient.writeQuery({
            query: GET_STOCK_TRANSFERS_QUERY,
            data,
        });
    } else {
        // If this is a new stockTransfer, not present in the cache
        const data = {
            stockTransfers: {
                hasMore: currentHasMore,
                stockTransfers: [...currentStockTransfers, stockTransferUpdated],
            },
        };
        apolloClient.writeQuery({
            query: GET_STOCK_TRANSFERS_QUERY,
            data,
        });
    }
};

export const stockTransferUpdatedHandler = (
    stockTransferUpdated: UpdateStockTransferMutation['updateStockTransfer'],
    stockTransferId: string,
) => {
    const data = { stockTransfer: stockTransferUpdated };
    apolloClient.writeFragment({
        id: stockTransferId,
        fragment: STOCK_TRANSFER_FRAGMENT,
        data,
    });
};
